import { render } from "./livePlatform.vue?vue&type=template&id=94b3dd8e"
import script from "./livePlatform.vue?vue&type=script&lang=js"
export * from "./livePlatform.vue?vue&type=script&lang=js"

import "./livePlatform.vue?vue&type=style&index=0&id=94b3dd8e&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__